<script>
    import { Link } from "svelte-routing";
    import { datasetStore } from '../stores/dataset';
    import { base } from '../utils/base';
    import { categories } from '../stores/dataset';
    
    // Add onMount for scroll behavior
    import { onMount, onDestroy } from 'svelte';

    onMount(() => {
        window.scrollTo(0, 0);
    });
    
    // Subscribe to the store
    $: originalCards = $datasetStore;
    
    // Declare cards variable
    let cards = [];
    
    // Search and filter state
    let searchQuery = '';
    let selectedCategory = 'all';
    
    // Add loading state
    let isLoading = false;
    let filterTimeout;
    
    // Modify the derived cards store to include loading state
    $: {
        isLoading = true;
        filterTimeout = setTimeout(() => {
            cards = originalCards
                .filter(card => {
                    const matchesSearch = card.dataset.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                        card.description.toLowerCase().includes(searchQuery.toLowerCase());
                    const matchesCategory = selectedCategory === 'all' || 
                                          card.category === selectedCategory;
                    return matchesSearch && matchesCategory;
                });
            isLoading = false;
        }, 300);
    }

    // Add cleanup using onDestroy
    onDestroy(() => {
        if (filterTimeout) clearTimeout(filterTimeout);
    });

    // No need for the categories derivation anymore since we're importing it
    // Just add 'all' to the imported categories
    $: filterCategories = ['all', ...categories];
</script>

<div class="bg-white min-h-screen">
    <!-- Filter Section -->
    <div class="pt-8 px-4 sm:px-6 lg:px-8">
        <div class="mb-6 space-y-4">
            <!-- Search Input -->
            <div class="flex justify-center mb-4">
                <input
                    type="text"
                    placeholder="Search products..."
                    bind:value={searchQuery}
                    class="w-full max-w-md px-4 py-2 border rounded-lg 
                           text-gray-800 placeholder-gray-500
                           focus:outline-none focus:border-blue-500"
                />
            </div>
            
            <!-- Category Filters -->
            <div class="flex flex-wrap gap-2 justify-center">
                {#each filterCategories as category}
                    <button
                        class="px-4 py-2 rounded-full text-sm font-medium border-2 transition-colors duration-200
                               ${selectedCategory === category 
                                 ? 'bg-blue-600 border-blue-700' 
                                 : 'bg-gray-200 text-gray-800 border-gray-300 hover:bg-gray-300 hover:border-gray-400'}"
                        on:click={() => selectedCategory = category}
                    >
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                    </button>
                {/each}
            </div>
        </div>
    </div>

    <!-- Card Grid Section -->
    <div class="px-4 sm:px-6 lg:px-8 w-full">
        {#if isLoading}
            <div class="flex justify-center items-center py-12">
                <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        {:else if cards.length === 0}
            <div class="text-center py-8">
                <p class="text-gray-500">No datasets found matching your criteria.</p>
            </div>
        {:else}
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {#each cards as card}
                    <div class="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                        <Link to={`${base}/dataDetail?id=${card.id}`}>
                            <img 
                                src={card.thumbnail}
                                alt={card.dataset}
                                class="w-full h-48 object-cover"
                            />
                        </Link>
                        <div class="p-4">
                            <Link to={`${base}/dataDetail?id=${card.id}`}>
                                <h3 class="text-xl font-semibold text-gray-800 hover:text-blue-600 transition-colors duration-200">
                                    {card.dataset}
                                </h3>
                            </Link>
                            <p class="text-gray-600 mt-2">{card.description}</p>
                        </div>
                    </div>
                {/each}
            </div>
        {/if}
    </div>
</div>
  